import React from 'react';
export default function Loading({ loadingSettings }) {
    var _a, _b;
    return (React.createElement("div", { className: ((_a = loadingSettings.classNames) === null || _a === void 0 ? void 0 : _a.root) || '' }, ((_b = loadingSettings.translations) === null || _b === void 0 ? void 0 : _b.loading) || 'Loading...'));
}
